import React, { useState, useEffect } from 'react';
import Select from "react-select";
import api from '../../../../../config/axios';
import Swal from 'sweetalert2';
import { autoCompleteCategoriasFinanceiras, autoCompleteCentrosDeCusto, autoCompleteCategoriasReceita } from "../../../../../components/utils/autocompletes";

import { FaRegSave, FaTimes } from 'react-icons/fa';

const ConfiguracaoModal = ({ configuracao, onClose, onConfiguracaoAtualizada }) => {
    const [formData, setFormData] = useState({
        nome: '',
        comanda_categoria_financeiro_id: '',
        comanda_centro_custo_id: '',
        receita_servico_categoria_id: '',
        receita_produto_categoria_id: '',
        comissao_categoria_financeiro_id: '',
        comissao_centro_custo_id: '',
        taxa_cartao_categoria_id: '',
        status: 'ativo'
    });
    const [tituloModal, setTituloModal] = useState("");
    
    const { inputPesquisaCategoria: inputCategoriaComanda, categoriasOptions: categoriasComandaOptions, handleAutoCompleteCategoriasFinanceiras: handleCategoriaComanda, handleFocusCategoriasFinanceiras: handleFocusCategoriaComanda } = autoCompleteCategoriasFinanceiras();
    const { inputPesquisaCentroCusto: inputCentroCustoComanda, centrosCustoOptions: centrosCustoComandaOptions, handleAutoCompleteCentrosDeCusto: handleCentroCustoComanda, handleFocusCentrosDeCusto: handleFocusCentroCustoComanda } = autoCompleteCentrosDeCusto();
    const { inputPesquisaCategoria: inputCategoriaReceitaServico, categoriasOptions: categoriasReceitaServicoOptions, handleAutoCompleteCategoriasReceita: handleCategoriaReceitaServico, handleFocusCategoriasReceita: handleFocusCategoriaReceitaServico } = autoCompleteCategoriasReceita();
    const { inputPesquisaCategoria: inputCategoriaReceitaProduto, categoriasOptions: categoriasReceitaProdutoOptions, handleAutoCompleteCategoriasReceita: handleCategoriaReceitaProduto, handleFocusCategoriasReceita: handleFocusCategoriaReceitaProduto } = autoCompleteCategoriasReceita();
    const { inputPesquisaCategoria: inputCategoriaComissao, categoriasOptions: categoriasComissaoOptions, handleAutoCompleteCategoriasFinanceiras: handleCategoriaComissao, handleFocusCategoriasFinanceiras: handleFocusCategoriaComissao } = autoCompleteCategoriasFinanceiras();
    const { inputPesquisaCentroCusto: inputCentroCustoComissao, centrosCustoOptions: centrosCustoComissaoOptions, handleAutoCompleteCentrosDeCusto: handleCentroCustoComissao, handleFocusCentrosDeCusto: handleFocusCentroCustoComissao } = autoCompleteCentrosDeCusto();
    const { inputPesquisaCategoria: inputCategoriaTaxaCartao, categoriasOptions: categoriasTaxaCartaoOptions, handleAutoCompleteCategoriasFinanceiras: handleCategoriaTaxaCartao, handleFocusCategoriasFinanceiras: handleFocusCategoriaTaxaCartao } = autoCompleteCategoriasFinanceiras();

    const customStyles = {
        menu: (provided) => ({
            ...provided,
            whiteSpace: "pre-line",
        }),
        option: (provided) => ({
            ...provided,
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
        }),
    };

    useEffect(() => {
        if (configuracao != null) {
            setFormData({
                nome: configuracao.nome || '',
                comanda_categoria_financeiro_id: configuracao.comandaCategoriaFinanceira && configuracao.comandaCategoriaFinanceira.id && configuracao.comandaCategoriaFinanceira.nome ?
                    { value: configuracao.comandaCategoriaFinanceira.id, label: configuracao.comandaCategoriaFinanceira.nome } : '',
                comanda_centro_custo_id: configuracao.comandaCentroCusto && configuracao.comandaCentroCusto.id && configuracao.comandaCentroCusto.nome ?
                    { value: configuracao.comandaCentroCusto.id, label: configuracao.comandaCentroCusto.nome } : '',
                receita_servico_categoria_id: configuracao.receitaServicoCategoriaFinanceira && configuracao.receitaServicoCategoriaFinanceira.id && configuracao.receitaServicoCategoriaFinanceira.nome ?
                    { value: configuracao.receitaServicoCategoriaFinanceira.id, label: configuracao.receitaServicoCategoriaFinanceira.nome } : '',
                receita_produto_categoria_id: configuracao.receitaProdutoCategoriaFinanceira && configuracao.receitaProdutoCategoriaFinanceira.id && configuracao.receitaProdutoCategoriaFinanceira.nome ?
                    { value: configuracao.receitaProdutoCategoriaFinanceira.id, label: configuracao.receitaProdutoCategoriaFinanceira.nome } : '',
                comissao_categoria_financeiro_id: configuracao.comissaoCategoriaFinanceira && configuracao.comissaoCategoriaFinanceira.id && configuracao.comissaoCategoriaFinanceira.nome ?
                    { value: configuracao.comissaoCategoriaFinanceira.id, label: configuracao.comissaoCategoriaFinanceira.nome } : '',
                comissao_centro_custo_id: configuracao.comissaoCentroCusto && configuracao.comissaoCentroCusto.id && configuracao.comissaoCentroCusto.nome ?
                    { value: configuracao.comissaoCentroCusto.id, label: configuracao.comissaoCentroCusto.nome } : '',
                taxa_cartao_categoria_id: configuracao.taxaCartaoCategoriaFinanceira && configuracao.taxaCartaoCategoriaFinanceira.id && configuracao.taxaCartaoCategoriaFinanceira.nome ?
                    { value: configuracao.taxaCartaoCategoriaFinanceira.id, label: configuracao.taxaCartaoCategoriaFinanceira.nome } : '',
                status: configuracao.ativo ? 'ativo' : 'inativo'
            });
            setTituloModal('Editar Configuração Financeira');
        } else {
            setFormData({
                nome: '',
                comanda_categoria_financeiro_id: '',
                comanda_centro_custo_id: '',
                receita_servico_categoria_id: '',
                receita_produto_categoria_id: '',
                comissao_categoria_financeiro_id: '',
                comissao_centro_custo_id: '',
                taxa_cartao_categoria_id: '',
                status: 'ativo'
            });
            setTituloModal('Nova Configuração Financeira');
        }
    }, [configuracao]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSelectChange = (name, value) => {
        setFormData(prev => ({
            ...prev,
            [name]: value || ''
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const camposObrigatorios = [
            { campo: 'nome', label: 'Nome' },
            { campo: 'comanda_categoria_financeiro_id', label: 'Categoria Financeira para Comandas' },
            { campo: 'comanda_centro_custo_id', label: 'Centro de Custo para Comandas' },
            { campo: 'comissao_categoria_financeiro_id', label: 'Categoria Financeira para Comissões' },
            { campo: 'comissao_centro_custo_id', label: 'Centro de Custo para Comissões' }
        ];

        const camposInvalidos = camposObrigatorios.filter(({ campo }) => {
            const valor = formData[campo];
            if (typeof valor === 'string') return !valor.trim();
            if (typeof valor === 'object' && valor !== null) return !valor.value;
            return !valor;
        });

        if (camposInvalidos.length > 0) {
            Swal.fire(
                'Erro',
                `Os seguintes campos são obrigatórios: ${camposInvalidos.map(c => c.label).join(', ')}`,
                'error'
            );
            return;
        }

        const estaAtivando = formData.status === 'ativo' && (!configuracao || !configuracao.ativo);
        
        if (estaAtivando) {
            const confirmResult = await Swal.fire({
                title: 'Atenção!',
                text: 'Ao tornar essa configuração ativa, outra configuração será desativada automaticamente. Deseja prosseguir?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sim, prosseguir!',
                cancelButtonText: 'Cancelar'
            });

            if (!confirmResult.isConfirmed) {
                return;
            }
        }

        Swal.fire({
            title: "Carregando...",
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            const dataToSend = {
                nome: formData.nome,
                comanda_categoria_financeiro_id: formData.comanda_categoria_financeiro_id?.value || null,
                comanda_centro_custo_id: formData.comanda_centro_custo_id?.value || null,
                receita_servico_categoria_id: formData.receita_servico_categoria_id?.value || null,
                receita_produto_categoria_id: formData.receita_produto_categoria_id?.value || null,
                comissao_categoria_financeiro_id: formData.comissao_categoria_financeiro_id?.value || null,
                comissao_centro_custo_id: formData.comissao_centro_custo_id?.value || null,
                taxa_cartao_categoria_id: formData.taxa_cartao_categoria_id?.value || null,
                ativo: formData.status === 'ativo' ? true : false
            };

            if (configuracao) {
                await api.put(`/configuracoes-financeiras/${configuracao.id}`, dataToSend);
                Swal.fire("Sucesso", "Configuração atualizada com sucesso!", "success");
            } else {
                await api.post('/configuracoes-financeiras', dataToSend);
                Swal.fire("Sucesso", "Configuração criada com sucesso!", "success");
            }

            onConfiguracaoAtualizada();
        } catch (error) {
            Swal.close();
            Swal.fire('Erro', error.response.data.message || 'Erro ao salvar configuração.', 'error');
        }
    };

    return (
        <div className="modal fade show" tabIndex="-1" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
                <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                    <div className="modal-header">
                        <h4 className="fw-bold mt-2">{tituloModal}</h4>
                        <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
                    </div>

                    <div className="modal-body">
                        <form onSubmit={handleSubmit}>
                            <div className="row">
                                <div className="col-lg-8 col-12">
                                    <label className="form-label fw-bold">Nome</label>
                                    <input
                                        type="text"
                                        name="nome"
                                        className="form-control"
                                        value={formData.nome}
                                        onChange={handleChange}
                                        maxLength={255}
                                        required
                                        autoComplete="off"
                                    />
                                </div>
                                <div className="col-lg-4 col-12 mt-lg-0 mt-3">
                                    <label className="form-label fw-bold">Status</label>
                                    <select
                                        name="status"
                                        className="form-control"
                                        value={formData.status}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="ativo">Ativo</option>
                                        <option value="inativo">Inativo</option>
                                    </select>
                                </div>
                            </div>

                            <div className="row mt-4">
                                <div className="col-12">
                                    <h6 className="fw-bold">Para Comandas</h6>

                                    <div className="row mt-3">
                                        <div className="col-lg-6 col-12">
                                            <label className="form-label fw-bold">Categoria Financeira</label>
                                            <Select
                                                options={categoriasComandaOptions}
                                                styles={customStyles}
                                                onInputChange={(value) => {
                                                    handleCategoriaComanda(value);
                                                }}
                                                onFocus={handleFocusCategoriaComanda}
                                                onChange={(value) => handleSelectChange('comanda_categoria_financeiro_id', value)}
                                                placeholder="Digite o nome da categoria"
                                                isClearable
                                                menuPlacement="auto"
                                                menuPosition="fixed"
                                                noOptionsMessage={() => "Sem opções"}
                                                value={formData.comanda_categoria_financeiro_id}
                                                autoComplete="off"
                                            />
                                        </div>
                                        <div className="col-lg-6 col-12 mt-lg-0 mt-3">
                                            <label className="form-label fw-bold">Centro de Custo</label>
                                            <Select
                                                options={centrosCustoComandaOptions}
                                                styles={customStyles}
                                                onInputChange={(value) => {
                                                    handleCentroCustoComanda(value);
                                                }}
                                                onFocus={handleFocusCentroCustoComanda}
                                                onChange={(value) => handleSelectChange('comanda_centro_custo_id', value)}
                                                placeholder="Digite o nome do centro de custo"
                                                isClearable
                                                menuPlacement="auto"
                                                menuPosition="fixed"
                                                noOptionsMessage={() => "Sem opções"}
                                                value={formData.comanda_centro_custo_id}
                                                autoComplete="off"
                                            />
                                        </div>
                                        <div className="col-lg-6 col-12 mt-3">
                                            <label className="form-label fw-bold">Receita Serviços</label>
                                            <Select
                                                options={categoriasReceitaServicoOptions}
                                                styles={customStyles}
                                                onInputChange={(value) => {
                                                    handleCategoriaReceitaServico(value);
                                                }}
                                                onFocus={handleFocusCategoriaReceitaServico}
                                                onChange={(value) => handleSelectChange('receita_servico_categoria_id', value)}
                                                placeholder="Digite o nome da categoria"
                                                isClearable
                                                menuPlacement="auto"
                                                menuPosition="fixed"
                                                noOptionsMessage={() => "Sem opções"}
                                                value={formData.receita_servico_categoria_id}
                                                autoComplete="off"
                                            />
                                        </div>
                                        <div className="col-lg-6 col-12 mt-3">
                                            <label className="form-label fw-bold">Receita Produtos</label>
                                            <Select
                                                options={categoriasReceitaProdutoOptions}
                                                styles={customStyles}
                                                onInputChange={(value) => {
                                                    handleCategoriaReceitaProduto(value);
                                                }}
                                                onFocus={handleFocusCategoriaReceitaProduto}
                                                onChange={(value) => handleSelectChange('receita_produto_categoria_id', value)}
                                                placeholder="Digite o nome da categoria"
                                                isClearable
                                                menuPlacement="auto"
                                                menuPosition="fixed"
                                                noOptionsMessage={() => "Sem opções"}
                                                value={formData.receita_produto_categoria_id}
                                                autoComplete="off"
                                            />
                                        </div>
                                        <div className="col-lg-6 col-12 mt-3">
                                            <label className="form-label fw-bold">Taxa de Cartão</label>
                                            <Select
                                                options={categoriasTaxaCartaoOptions}
                                                styles={customStyles}
                                                onInputChange={(value) => {
                                                    handleCategoriaTaxaCartao(value);
                                                }}
                                                onFocus={handleFocusCategoriaTaxaCartao}
                                                onChange={(value) => handleSelectChange('taxa_cartao_categoria_id', value)}
                                                placeholder="Digite o nome da categoria"
                                                isClearable
                                                menuPlacement="auto"
                                                menuPosition="fixed"
                                                noOptionsMessage={() => "Sem opções"}
                                                value={formData.taxa_cartao_categoria_id}
                                                autoComplete="off"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row mt-4">
                                <div className="col-12">
                                    <h6 className="fw-bold">Para Comissões</h6>

                                    <div className="row mt-3">
                                        <div className="col-lg-6 col-12">
                                            <label className="form-label fw-bold">Categoria Financeira</label>
                                            <Select
                                                options={categoriasComissaoOptions}
                                                styles={customStyles}
                                                onInputChange={(value) => {
                                                    handleCategoriaComissao(value);
                                                }}
                                                onFocus={handleFocusCategoriaComissao}
                                                onChange={(value) => handleSelectChange('comissao_categoria_financeiro_id', value)}
                                                placeholder="Digite o nome da categoria"
                                                isClearable
                                                menuPlacement="auto"
                                                menuPosition="fixed"
                                                noOptionsMessage={() => "Sem opções"}
                                                value={formData.comissao_categoria_financeiro_id}
                                                autoComplete="off"
                                            />
                                        </div>
                                        <div className="col-lg-6 col-12 mt-lg-0 mt-3">
                                            <label className="form-label fw-bold">Centro de Custo</label>
                                            <Select
                                                options={centrosCustoComissaoOptions}
                                                styles={customStyles}
                                                onInputChange={(value) => {
                                                    handleCentroCustoComissao(value);
                                                }}
                                                onFocus={handleFocusCentroCustoComissao}
                                                onChange={(value) => handleSelectChange('comissao_centro_custo_id', value)}
                                                placeholder="Digite o nome do centro de custo"
                                                isClearable
                                                menuPlacement="auto"
                                                menuPosition="fixed"
                                                noOptionsMessage={() => "Sem opções"}
                                                value={formData.comissao_centro_custo_id}
                                                autoComplete="off"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>

                    <div className="modal-footer mt-4">
                        <div className="row">
                            <div className="col-12 text-end">
                                <button className="btn btn-outline-danger" type="button" onClick={onClose}>
                                    <FaTimes /> Fechar
                                </button>
                                <button className="btn btn-custom-primary ms-3" type="submit" onClick={handleSubmit}>
                                    <FaRegSave /> Salvar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConfiguracaoModal; 